import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Meta
export const getMetaService = () => {
  return http.get(`${base_url}/meta`);
};
// End Meta

// Start Notification
export const createNotificationsService = (body) => {
  return http.post(`${base_url}/notification`, body);
};
// End Notification
